import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Clock",
  "use": "Clock-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"Clock\"><path fill-rule=\"evenodd\" d=\"M3.498 16.123l-1.362 1.41L1.5 12.59l4.963.463-1.476 1.529a6.875 6.875 0 1 0-2.849-5.176H.009a9 9 0 1 1 3.489 6.717zm6.06-7.34h3.748v2.12H7.4v-2.12h.037v-3.44h2.12v3.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol